/**
 * UI modules whose visibility a super-admin can hide per business. Mirrors the backend
 * modules.config.ts catalog. `navTitle` matches the sidebar item title; `path` is the route prefix
 * used by the route guard to block direct navigation to a hidden module.
 */
export type ModuleKey =
  | "reservations"
  | "orders"
  | "kitchen"
  | "customers"
  | "inventory"
  | "invoices"
  | "accounting"
  | "insights"
  | "vat_report"
  | "standard_view"
  | "activity"
  | "transactions"
  | "staffs";

export type ModuleDef = { key: ModuleKey; label: string; navTitle: string; path: string };

export const MODULES: ModuleDef[] = [
  { key: "reservations", label: "Reservations", navTitle: "Reservations", path: "/dashboard/reservations" },
  { key: "orders", label: "Orders", navTitle: "Orders", path: "/dashboard/orders" },
  { key: "kitchen", label: "Kitchen Display", navTitle: "Kitchen Display", path: "/dashboard/kitchen" },
  { key: "customers", label: "Customers", navTitle: "Customers", path: "/dashboard/customers" },
  { key: "inventory", label: "Inventory", navTitle: "Inventory", path: "/dashboard/inventory" },
  { key: "invoices", label: "Invoices", navTitle: "Invoices", path: "/dashboard/invoices" },
  { key: "accounting", label: "Accounting", navTitle: "Accounting", path: "/dashboard/accounting" },
  { key: "insights", label: "Insights", navTitle: "Insights", path: "/dashboard/insights" },
  { key: "vat_report", label: "VAT Report", navTitle: "VAT Report", path: "/dashboard/vat-report" },
  { key: "standard_view", label: "Standard View", navTitle: "Standard View", path: "/dashboard/standard-view" },
  { key: "activity", label: "Activity", navTitle: "Activity", path: "/dashboard/activity" },
  { key: "transactions", label: "Transactions", navTitle: "Transactions", path: "/dashboard/transactions" },
  { key: "staffs", label: "Staff", navTitle: "Staffs", path: "/dashboard/staffs" },
];

/** Sidebar item title -> module key, for filtering nav without annotating every item. */
export const TITLE_TO_MODULE: Record<string, ModuleKey> = MODULES.reduce(
  (acc, m) => {
    acc[m.navTitle] = m.key;
    return acc;
  },
  {} as Record<string, ModuleKey>,
);

/** Resolve the module a pathname belongs to (longest path-prefix wins). */
export const moduleForPath = (pathname: string): ModuleKey | undefined => {
  let match: ModuleDef | undefined;
  for (const m of MODULES) {
    if (pathname === m.path || pathname.startsWith(`${m.path}/`)) {
      if (!match || m.path.length > match.path.length) match = m;
    }
  }
  return match?.key;
};
